import React from "react";
import Banner from "./banner";
import Features from "./features";
import Current from "./current";
import Explore from "./explore";

function Index() {
  return (
    <>
      <Banner />
      <Features />

      {/* Who Is the Biggest Club Section */}
      <section className="bg-background px-5 py-12 md:py-16">
        <div className="container mx-auto">
          {/* Section Header */}
          <div className="text-center mb-10">
            <h2 className="headingB pb-3 text-gray-900">
              Who Is the Biggest Club Right Now?
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-redBtn to-customBlue mx-auto rounded-full"></div>
          </div>

          {/* Content Card */}
          <div className="mx-auto max-w-5xl">
            <div className="bg-white rounded-2xl shadow-lg p-6 md:p-10 border border-gray-100">
              <p className="commonTxt md:text-lg leading-relaxed text-center mb-6">
                In the vibrant world of football, the quest to determine the
                'biggest club' is an ongoing saga that captivates fans,
                analysts, and pundits alike. Our concept emphasizes that the
                size of the club is{" "}
                <span className="font-bold text-redBtn">dynamic</span>, i.e. it
                is not fixed but constantly evolving as teams rise and fall, and
                as achievements and performances shape their legacies.
              </p>

              <div className="bg-gradient-to-r from-blue-50 to-red-50 rounded-xl p-6 border-l-4 border-customBlue">
                <p className="text-gray-700 text-base md:text-lg italic text-center">
                  For example Manchester United may have been the biggest team
                  in the Sir Alex Ferguson era, but{" "}
                  <span className="font-semibold text-customBlue">
                    are they still so today?
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Current />
      <Explore />
    </>
  );
}

export default Index;
